import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/feegow-background.jpg'


const _withScopeId = n => (_pushScopeId("data-v-e0194264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generic-fragment" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "import-path" }
const _hoisted_6 = { class: "status-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-label" }, "Module Script Status", -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "duration"
}
const _hoisted_10 = { class: "preview-wrapper" }
const _hoisted_11 = { class: "slot-overlay" }
const _hoisted_12 = {
  key: 0,
  class: "feegow-background"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Simulated Background"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "error-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Script Load Failed", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We couldn't load one or more required scripts:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please check your dev server and try again.", -1))
const _hoisted_19 = { class: "modal-buttons" }

import { onMounted, ref, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericFragment',
  props: {
    title: {},
    description: {},
    scriptName: {},
    useBackground: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const scriptStatus = ref("Loading");
const showErrorPopup = ref(false);
const loadStart = ref<number | null>(null);
const loadDuration = ref<number | null>(null);

const scriptsToLoad = [
  "chunk-vendors.js",
  "chunk-common.js",
  `${props.scriptName}.js`,
];

const statusClass = computed(() => {
  return {
    loading: scriptStatus.value === "Loading",
    loaded: scriptStatus.value === "Loaded",
    failed: scriptStatus.value === "Failed",
  };
});

function appendScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `http://localhost:8080/js/${src}`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load: ${src}`));

    document.body.appendChild(script);
  });
}

async function loadScripts() {
  scriptStatus.value = "Loading";
  loadStart.value = performance.now();
  try {
    for (const script of scriptsToLoad) {
      await appendScript(script);
    }
    scriptStatus.value = "Loaded";
  } catch (err) {
    scriptStatus.value = "Failed";
  } finally {
    loadDuration.value = Math.round(performance.now() - (loadStart.value || 0));
  }
}

function retryLoad() {
  showErrorPopup.value = false;
  loadScripts();
}

function openErrorModal() {
  showErrorPopup.value = true;
}

// Simulate user session
document.userProperties = {
  idInTable: 8,
  userId: 1,
  licencaID: 17973,
  tipoUsuario: "profissionais",
};

const previewWidth = ref(Math.floor(window.innerWidth * 0.98));

function initResize(e: MouseEvent) {
  const startX = e.clientX;
  const startWidth = previewWidth.value;

  function onMouseMove(e: MouseEvent) {
    const delta = e.clientX - startX;
    previewWidth.value = Math.max(320, startWidth + delta); // minimum width
  }

  function stopResize() {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", stopResize);
  }

  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", stopResize);
}

onMounted(() => {
  loadScripts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1),
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(" Imports: "),
          _createElementVNode("code", null, "http://localhost:8080/js/" + _toDisplayString(_ctx.scriptName) + ".js", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", {
          class: _normalizeClass(["status", statusClass.value]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scriptStatus.value === 'Failed' && openErrorModal())),
          title: scriptStatus.value === 'Failed' ? 'Click to see error details' : ''
        }, [
          _createTextVNode(_toDisplayString(scriptStatus.value.toUpperCase()) + " ", 1),
          (loadDuration.value !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, " · " + _toDisplayString(loadDuration.value) + "ms ", 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: "preview-box",
        style: _normalizeStyle({ width: previewWidth.value + 'px' })
      }, [
        _createElementVNode("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (props.useBackground)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "resizer",
          onMousedown: initResize
        }, null, 32)
      ], 4)
    ]),
    (showErrorPopup.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "error-modal",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showErrorPopup.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("ul", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scriptsToLoad, (src) => {
                return _createElementVNode("li", { key: src }, [
                  _createElementVNode("code", null, "http://localhost:8080/js/" + _toDisplayString(src), 1)
                ])
              }), 64))
            ]),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", { onClick: retryLoad }, "Retry"),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showErrorPopup.value = false))
              }, "Close")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})